import React from "react";
import "react-loading-skeleton/dist/skeleton.css";

import { Router } from "@components/Router";

export function App(): JSX.Element {
    return <Router />;
}
